import { render } from "./ButtonIcon.vue?vue&type=template&id=05403bc1&scoped=true"
import script from "./ButtonIcon.vue?vue&type=script&lang=js"
export * from "./ButtonIcon.vue?vue&type=script&lang=js"

import "./ButtonIcon.vue?vue&type=style&index=0&id=05403bc1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05403bc1"

export default script